import { render, staticRenderFns } from "./home_tab.vue?vue&type=template&id=adb235fe&scoped=true"
import script from "./home_tab.vue?vue&type=script&lang=js"
export * from "./home_tab.vue?vue&type=script&lang=js"
import style0 from "./home_tab.vue?vue&type=style&index=0&id=adb235fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb235fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adb235fe')) {
      api.createRecord('adb235fe', component.options)
    } else {
      api.reload('adb235fe', component.options)
    }
    module.hot.accept("./home_tab.vue?vue&type=template&id=adb235fe&scoped=true", function () {
      api.rerender('adb235fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_tab.vue"
export default component.exports